import React from 'react';
import { ArrowRight, Sparkles } from 'lucide-react';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center bg-gradient-to-br from-navy-900 via-navy-800 to-navy-700 pt-16">
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0icmdiYSgyNTUsMjU1LDI1NSwwLjAzKSIgc3Ryb2tlLXdpZHRoPSIxIi8+PC9wYXR0ZXJuPjwvZGVmcz48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJ1cmwoI2dyaWQpIi8+PC9zdmc+')] opacity-30"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 relative z-10">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div className="inline-flex items-center gap-2 bg-navy-700/50 backdrop-blur-sm px-4 py-2 rounded-full border border-silver-600/30">
              <Sparkles className="text-silver-300" size={16} />
              <span className="text-silver-200 text-sm">Premium Digital Printing & Packaging Solutions</span>
            </div>

            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight">
              Transform your vision with{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-silver-300 to-silver-500">
                intelligent printing
              </span>
            </h1>

            <p className="text-xl text-silver-300 leading-relaxed">
              Get premium quality prints, packaging solutions, expert design services, and cutting-edge printing technology. 
              Deliver your projects faster and smarter with our professional solutions.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <button 
                onClick={scrollToContact}
                className="bg-white text-navy-800 px-8 py-4 rounded-lg font-semibold hover:bg-silver-100 transition-all duration-300 flex items-center justify-center gap-2 shadow-lg hover:shadow-xl"
              >
                Get Started
                <ArrowRight size={20} />
              </button>
              <button 
                onClick={() => document.getElementById('products').scrollIntoView({ behavior: 'smooth' })}
                className="border-2 border-silver-400 text-silver-100 px-8 py-4 rounded-lg font-semibold hover:bg-silver-400/10 transition-all duration-300"
              >
                View Products
              </button>
            </div>

            <div className="flex items-center gap-8 pt-8">
              <div className="flex -space-x-3">
                <div className="w-10 h-10 rounded-full bg-silver-400 border-2 border-navy-800 flex items-center justify-center text-navy-800 font-semibold">JD</div>
                <div className="w-10 h-10 rounded-full bg-silver-300 border-2 border-navy-800 flex items-center justify-center text-navy-800 font-semibold">SK</div>
                <div className="w-10 h-10 rounded-full bg-silver-500 border-2 border-navy-800 flex items-center justify-center text-navy-800 font-semibold">AL</div>
              </div>
              <div>
                <p className="text-2xl font-bold text-white">500+</p>
                <p className="text-silver-400 text-sm">Happy clients daily</p>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-r from-silver-400/20 to-silver-600/20 rounded-3xl blur-3xl"></div>
            <div className="relative bg-navy-700/50 backdrop-blur-sm rounded-3xl overflow-hidden border border-silver-600/30 shadow-2xl">
              <video 
                autoPlay
                loop
                muted
                playsInline
                className="w-full h-full object-cover min-h-[400px] md:min-h-[500px]"
              >
                <source src={`${process.env.PUBLIC_URL}/GDP_Animation.mp4`} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
